import React from "react";

import closeDarkIcon from "../../assets/img/icons/closeDarkIcon.svg";
import closeOrangeIcon from "../../assets/img/icons/closeOrangeIcon.svg";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  id?: string;
  closeIcon?: "dark" | "orange";
  backdropClassName?: string;
  modalClassName?: string;
  containerClassName?: string;
  showCloseButton?: boolean;
  closeOnBackdropClick?: boolean;
  useCustomStructure?: boolean;
}

function Modal({
  isOpen,
  onClose,
  children,
  id = "modal",
  closeIcon = "dark",
  backdropClassName = "backdrop-blur-sm",
  modalClassName = "",
  containerClassName = "",
  showCloseButton = true,
  closeOnBackdropClick = true,
  useCustomStructure = false,
}: ModalProps) {
  if (!isOpen) return null;

  const handleBackgroundClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (
      closeOnBackdropClick &&
      e.target instanceof HTMLElement &&
      e.target.id === id
    ) {
      onClose();
    }
  };

  const closeIconSrc = closeIcon === "orange" ? closeOrangeIcon : closeDarkIcon;

  // If using custom structure, let the children handle the layout
  if (useCustomStructure) {
    return (
      <div
        id={id}
        className={`fixed right-0 top-0 left-0 bottom-0 z-50 flex justify-center items-center p-[0.375rem] pt-[4rem] ${backdropClassName}`}
        onClick={handleBackgroundClick}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      id={id}
      className={`fixed right-0 top-0 left-0 bottom-0 z-50 flex justify-center items-center p-[0.375rem] pt-[4rem] ${backdropClassName}`}
      onClick={handleBackgroundClick}
    >
      <div
        className={`bg-dark rounded-[1.25rem] w-full max-w-[60rem] p-10 relative h-full md:h-auto md:py-[4rem] md:px-[2.25rem] bg-blue-light flex items-center justify-center overflow-y-auto md:shadow-2xl ${modalClassName}`}
      >
        {showCloseButton && (
          <div
            className="absolute top-1 right-1 cursor-pointer p-3"
            onClick={onClose}
          >
            <img className="w-[0.79rem]" src={closeIconSrc} alt="Close modal" />
          </div>
        )}

        <div className={containerClassName}>{children}</div>
      </div>
    </div>
  );
}

export default Modal;
